export function getSafeAuthRedirect(candidate, fallback = "/") {
  if (typeof candidate !== "string" || !candidate.startsWith("/") || candidate.startsWith("//")) {
    return fallback;
  }

  return candidate;
}

export function buildSignInPath(location) {
  const returnTo = `${location?.pathname || "/"}${location?.search || ""}${location?.hash || ""}`;
  return `/auth?redirect=${encodeURIComponent(getSafeAuthRedirect(returnTo))}`;
}
